<template>
  <div id="sidebar-category" class="col-xs-12" style="padding: 0">
    <div class="box_style_2 rightcontent" id="myOrdersDiv" style="padding: 5px">
      <h4>My Orders</h4>
      <div class="row">
        <div class="col-md-12" id="myOrders" style="padding: 0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as render from "../utils/render";

export default {
  name: "MyOrderSide",
  created() {
    this.$store.dispatch("getMyOrders").then((myOrders) => {
      if (myOrders.length > 0) {
        myOrders.forEach((order) => {
          render.myOrdersSide(order);
          let button_open = "#openOrderSide_" + order.order_no;
          let button_close = "#closeOrderSide_" + order.order_no;
          let button_repeat = "#repeatOrderSide_" + order.order_no;
          $(document).on("click", button_open, ($event) => {
            this.showHideOrderDetails($event, "open");
          });
          $(document).on("click", button_close, ($event) => {
            this.showHideOrderDetails($event, "close");
          });
          $(document).on("click", button_repeat, ($event) => {
            this.repeatOrder($event, order.order_no);
          });
          order.order_menu.forEach((menu) => {
            render.menuItemDetails(menu, order.order_no);
          });
        });
      }else{
        $("#myOrders").html('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;No Previous Orders');
      }
    }),
      this.$store.watch((getters) => getters.open_menu);
  },
  computed: {
    ...mapGetters(["open_menu", "myOrders"]),
  },
  methods: {
    showHideOrderDetails(event, type) {
      if (type === "open") {
        let id = $(event.target).attr("data-id");
        $("#" + id).css({ display: "block" });
        $("#openOrderSide_" + id).css({ display: "none" });
        $("#closeOrderSide_" + id).css({ display: "inline-block" });
      } else {
        let id = $(event.target).attr("data-id");
        $("#" + id).css({ display: "none" });
        $("#openOrderSide_" + id).css({ display: "inline-block" });
        $("#closeOrderSide_" + id).css({ display: "none" });
      }
    },
    openMenu(event) {
      this.$store.dispatch("openMenu", event);
    },
    repeatOrder(event, orderNo) {
      $("#repeatOrderSide_" + orderNo).html('Pls Wait <i class="fa fa-spinner fa-spin"></i>');
      this.$store.dispatch("repeatOrder", orderNo).then((rdata) => {
        $("#repeatOrderSide_" + orderNo).html("Repeat");
        this.$fire({
          html: "<b>" + rdata.message + "</b>",
          title: "Success",
          type: "success",
          timer: 3000,
        });
        this.$router.push("/").catch((err) => {
          console.log(err.message);
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumb_menu_list {
  height: 60px;
}
.table > thead > tr > td {
  padding: 3px;
}
.rightcontent {
  background: rgb(255, 255, 255);
  padding: 10px;
  min-height: auto !important;
}
</style>
